(function fix() {
  // Supprimer l'overlay
  var o = document.querySelector('.sf-th-v');
  if (o) o.remove();
  // Retirer classe de blocage
  document.body.classList.remove('sf-tr');
  // Forcer le scroll
  document.documentElement.style.setProperty('height', 'auto', 'important');
  document.documentElement.style.setProperty('overflow', 'visible', 'important');
  document.body.style.setProperty('height', 'auto', 'important');
  document.body.style.setProperty('overflow-y', 'visible', 'important');
})();

document.addEventListener('DOMContentLoaded', function() {
  var o = document.querySelector('.sf-th-v');
  if (o) o.remove();
  document.body.classList.remove('sf-tr');
  document.documentElement.style.setProperty('height', 'auto', 'important');
  document.documentElement.style.setProperty('overflow', 'visible', 'important');
  document.body.style.setProperty('height', 'auto', 'important');
  document.body.style.setProperty('overflow-y', 'visible', 'important');
});

new MutationObserver(function(m) {
  m.forEach(function(r) {
    r.addedNodes.forEach(function(n) {
      if (n.nodeType === 1 && n.classList && n.classList.contains('sf-th-v')) {
        n.remove();
        document.documentElement.style.setProperty('height', 'auto', 'important');
        document.documentElement.style.setProperty('overflow', 'visible', 'important');
        document.body.style.setProperty('height', 'auto', 'important');
        document.body.style.setProperty('overflow-y', 'visible', 'important');
        document.body.classList.remove('sf-tr');
      }
    });
  });
}).observe(document.documentElement, { childList: true, subtree: true });
